<div class="setting-sidebar" [ngClass]="{ 'sidebar-open': isOpen }">
  <div class="setting-sidebar-header">
    <button class="btn btn-link" (click)="closeSidebar()">
      <a class="navbar-brand" [routerLink]="['/']">
        <img class="logo-img" [src]="'/assets/images/eezyimport-logo-m.svg'" alt="logo" />
      </a>
      <span>{{ "MENU.ACCOUNT_SETTINGS" | translate }}</span>
    </button>
  </div>
  <div class="setting-sidebar-body">
    <button class="btn btn-link" (click)="goToOrganization()">
      <span>{{ "LABELS.ORGANIZATION" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <button class="btn btn-link" (click)="goToCompany()">
      <span>{{ (companies.length > 1 ? "LABELS.IMPORTERS_OF_RECORD" : "LABELS.IMPORTER_OF_RECORD") | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <button class="btn btn-link" (click)="goToUserDetails()">
      <span>{{ "LABELS.USER_DETAILS" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <button class="btn btn-link" (click)="goToBillingHistory()">
      <span>{{ "MENU.BILLING_HISTORY" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <hr />
    <button *ngIf="isShowSelfFiller" class="btn btn-link" [routerLink]="['/companies', 'self-filer']">
      <span>{{ "MENU.SELF_FILER" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <button class="btn btn-link" (click)="goToLegalTerms()">
      <span>{{ "MENU.LEGAL_TERMS" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <button class="btn btn-link" (click)="goToPolicy()">
      <span>{{ "PAGE.POLICY.PRIVACY_POLICY" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <button class="btn btn-link" (click)="onOpenCookieSettings()">
      <span>{{ "COOKIES_SETTINGS" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
    <button class="btn btn-link" (click)="logout()">
      <span>{{ "MENU.LOG_OUT" | translate }}</span>
      <i class="fa fa-fw fa-chevron-right"></i>
    </button>
  </div>
</div>
